export const COMMON_USER_UNAUTHORIZED_EVENT = 'user-unauthorized';
